module.exports = { "default": require("core-js/library/fn/symbol/iterator"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/rc-align/~/babel-runtime/core-js/symbol/iterator.js
// module id = 485
// module chunks = 0 1